import { DependencyList, EffectCallback, useLayoutEffect, useRef } from "react"

export function useEffectButNotOnMount(effect: EffectCallback, deps?: DependencyList) {
  const mounted = useRef<boolean>(false)

  useLayoutEffect(() => {
    if (mounted.current) {
      effect()
    } else {
      mounted.current = true
    }
  }, deps)
}
